/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x4ad9=['Position'];(function(_0x14b26d,_0x4ad9c1){var _0xdbaef3=function(_0x2bf752){while(--_0x2bf752){_0x14b26d['push'](_0x14b26d['shift']());}};_0xdbaef3(++_0x4ad9c1);}(_0x4ad9,0xba));var _0xdbae=function(_0x14b26d,_0x4ad9c1){_0x14b26d=_0x14b26d-0x0;var _0xdbaef3=_0x4ad9[_0x14b26d];return _0xdbaef3;};import _0x3572a4 from'./operationcompressor';export default class h extends _0x3572a4{static get['description'](){return{'fields':{'splitPosition':{'type':'Position','id':0x1},'graveyardPosition':{'type':_0xdbae('0x0'),'id':0x2},'howMany':{'type':'uint32','id':0x3},'insertionPosition':{'type':_0xdbae('0x0'),'id':0x4},'wasUndone':{'type':'bool','id':0x5}}};}}